module.exports = __webpack_public_path__ + "img/login-image.4ab1877d.jpg";